import { render, staticRenderFns } from "./invKnowledgeTest.vue?vue&type=template&id=2f01cd14"
import script from "./invKnowledgeTest.vue?vue&type=script&lang=js"
export * from "./invKnowledgeTest.vue?vue&type=script&lang=js"
import style0 from "./invKnowledgeTest.vue?vue&type=style&index=0&id=2f01cd14&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports